<template>
  <div class="index-call-to-action-section">
    <call-to-action>
      <template v-slot:info-box>
        <div class="title heading-3-regular">{{ fields.field_one.value.text }}</div>
        <div class="title heading-3-bold">{{ fields.field_one.value.text2 }}</div>
        <div class="button-container">
          <seu-button
            :label="fields.field_one.value.buttonLabel"
            :button-link="fields.field_one.value.buttonLink"
            :button-icon-before="buttonIcon"
          />
        </div>
      </template>
      <template v-slot:image-box>
        <img v-scroll-animate :src="fields.field_one.value.image" alt="" v-scroll-animate>
      </template>
    </call-to-action>
  </div>
</template>

<script>
import SeuButton from "/seu-frontend/components/SeuButton";
import CallToAction from "/seu-frontend/components/section-fields/CallToAction";

export default {
  name: 'IndexCallToActionSection',
  components: {CallToAction, SeuButton,},
  props: {
    fields: {
      type: Object
    }
  },

  data() {
    return {
      buttonIcon: require('../../assets/static-icons/icon-mail.svg')
    }
  }

}
</script>

<style lang="scss">
@import "IndexCallToActionSection.scss";
</style>
